import * as React from 'react';
import { Input, InputAdornment } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export var MobileInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var value = props.value,
      onValueChange = props.onValueChange,
      unit = props.unit,
      errorMessage = props.errorMessage,
      placeholder = props.placeholder;
  return /*#__PURE__*/_jsx(Input, {
    ref: ref,
    value: value,
    onBlur: props.onBlur,
    onChange: function onChange(e) {
      return onValueChange(e.target.value);
    },
    maxLength: 4,
    placeholder: placeholder || '77',
    rightAdornment: /*#__PURE__*/_jsx(InputAdornment, {
      children: unit
    }),
    size: "M",
    invalid: Boolean(errorMessage),
    "data-testid": "area_input"
  });
});
MobileInput.displayName = 'MobileInput';